<template>
  <div>
    <scale-editor-collapsed
      v-model="computedChoices"
      v-if="isCollapsed"
      :question="value"
      :isEditable="isEditable"
      :isReverseOrder="value.isChoiceOrderReversed"
      @onToggleCollapse="handleToggleCollapse"
    ></scale-editor-collapsed>
    <scale-editor-expanded
      v-model="computedChoices"
      v-else
      :question="value"
      :isEditable="isEditable"
      :isReverseOrder="value.isChoiceOrderReversed"
      @onToggleCollapse="handleToggleCollapse"
      @onReverseOrder="handleReverseOrder"
    ></scale-editor-expanded>
  </div>
</template>

<script>
import ScaleEditorCollapsed from './ScaleEditorCollapsed';
import ScaleEditorExpanded from './ScaleEditorExpanded';

export default {
  name: 'ScaleEditor',
  components: {
    ScaleEditorCollapsed,
    ScaleEditorExpanded,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedChoices: {
      get() {
        return this.value.choices || [];
      },
      set(choices) {
        this.$emit('input', { ...this.value, choices });
      },
    },
  },
  methods: {
    handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },

    handleReverseOrder(isReversed) {
      this.$store.dispatch('surveybuilder/updateQuestion', {
        ...this.value,
        isChoiceOrderReversed: isReversed,
      });
    },

    sortChoices(choices) {
      return choices.sort((a, b) => a.order - b.order);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ScaleEditor.vue?dea7e130